<div class="ir-area ir-mask th-mask">
  <div class="ir-modal th-modal">
    <modal-header [plugin]="plugin" [menuModal]="menuModal" [pluginType]="'participants'"></modal-header>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <table class="ir-plugin-table" style="margin-bottom: 50px">
          <tr class="th-plugin-line--header">
            <td class="th-plugin-line--data" style="width: 50%">
              <span>{{ 'plugins.participants.participant.name' | translate }}</span>
            </td>
            <td class="th-plugin-line--data" style="width: 50%">
              <span>{{ 'plugins.participants.participant.function' | translate }}</span>
            </td>
          </tr>
          <tr class="th-plugin-line--input">
            <td>
              <input type="text" class="ir-form-set" name="id" [(ngModel)]="participant.Name" />
            </td>
            <td>
              <input type="text" class="ir-form-set" name="page" [(ngModel)]="participant.Function" />
            </td>
            <td class="th-plugin-line--numbers add-parts">
              <i class="material-icons" (click)="add()">add_circle</i>
            </td>
          </tr>
        </table>
        <table class="ir-modal-table">
          <tr>
            <td class="margin">
              <h2>
                <span>{{ 'plugins.participants.name' | translate }}</span>
              </h2>
            </td>
            <td class="margin">
              <div class="ir-form-group">
                <div class="ir-line ir-select th-select" (click)="openParticipantsSelector()">
                  <div class="ir-line--right">
                    <div class="ir-btn th-btn-modal--content">
                      <i class="material-icons">arrow_drop_down</i>
                    </div>
                  </div>
                  <div class="ir-line-content">
                    <span [innerHtml]="getSelectedValues()"></span>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
            <span>{{ 'common.cancel' | translate }}</span>
          </div>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
            type="button"
            (click)="save()"
            *ngIf="!processing"
          >
            <span>{{ 'common.save-changes' | translate }}</span>
          </button>
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right"
            type="submit"
            *ngIf="processing"
          >
            <span>{{ 'common.processing' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<modal #menuModal (modalOutput)="selectMenu($event)"></modal>
<confirm
  #deleteConfirm
  (confirmOutput)="deletePlugin($event)"
  [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.sure-to-delete' | translate"
  [danger]="true"
></confirm>
<modal (modalOutput)="selectParticipants($event)" #participantsModal></modal>
